import { render, staticRenderFns } from "./industryOverview.vue?vue&type=template&id=700a3228&scoped=true"
import script from "./industryOverview.vue?vue&type=script&lang=js"
export * from "./industryOverview.vue?vue&type=script&lang=js"
import style0 from "./industryOverview.vue?vue&type=style&index=0&id=700a3228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a3228",
  null
  
)

export default component.exports